import LocalStorage from '../../local-storage';
import Config from '../../config';

import { clearAuthCookie } from './web/ManageAuthCookie';

const signOut = async () => {
  // LocalStorage.removeItem('@Nerdfitness:jwtoken');

  LocalStorage.removeItem(Config.LOCAL_STORAGE_AUTH_KEY);
  // Remove all local storage data
  // LocalStorage.clear();

  clearAuthCookie();

  // Just refresh the page, it will route back to sign-in
  window.location.reload();
};

export default signOut;
